// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"fac266c0","453":"2cb9da49"}[chunkId] + ".chunk.js";
};